<div class="row justify-content-center position-relative col-12" style="margin-top: 15vh;">
  <div class="col-11">
    <div style="z-index: 100;background-color: white;" class="row mt-2 mr-0 d-flex">
      <h3 class="font-weight-bold text-uppercase ml-2">{{ executionType === 'TEST_CASE' ? 'Test Case' : executionType === 'TEST_SUITE' ? 'Test Suite' : 'Master Suite' }} History</h3>
      <div class="filter-icon ml-auto">
        <button class="btn btn-filter text-white mr-2 trigger-collapse-btn" title="Filter" data-toggle="collapse" data-target="#collapseExample" aria-expanded="true" aria-controls="collapseExample">
          <i class='fas fa-filter'></i></button>
      </div>
    </div>
    <div class="filterContent">
      <div class="collapse " id="collapseExample">
        <form [formGroup]="historyListSearchForm" (ngSubmit)="filterData()" class="search-form">
          <div class="row">
            <div class="col-4 form-group">
              <label for="search-keyword">Search Keyword</label>
              <input id="search-keyword" class="form-control form-control-sm" placeholder="Search Keyword" formControlName="keyword">
            </div>
            <div class="col-4 form-group">
              <label for="project-list">Project</label>
              <ng-select class="custom-style" id="project-list" [items]="myProjects" bindLabel="name" bindValue="id" placeholder="Select project(s)" [searchable]="true" [multiple]="true" formControlName="projectIds">
                <ng-template ng-option-tmp let-item="item">
                  <div title="{{item.name}}" class="text-truncate">{{item.name}}</div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-4 form-group">
              <label for="executed-by">Executed By</label>
              <ng-select class="custom-style" id="executed-by" [items]="users" bindLabel="displayName" bindValue="id" placeholder="Select executed by" [searchable]="true" [multiple]="false" formControlName="executedBy">
                <ng-option [value]="">Select executed by</ng-option>
              </ng-select>
            </div>
            <div class="col-4 form-group">
              <label for="execution-status">Status</label>
              <ng-select class="custom-style" id="execution-status" [items]="executionStatusList" placeholder="Select Status" [searchable]="true" [multiple]="false" formControlName="executionStatus">
                <ng-option [value]="">Select Status</ng-option>
              </ng-select>
            </div>
            <div class="col-4 form-group">
              <label for="from-date">From</label>
              <input id="from-date" class="form-control form-control-sm" container="body" placeholder="yyyy-mm-dd" ngbDatepicker #fromDateDp="ngbDatepicker" formControlName="fromDate" [maxDate]="maxDate" (click)="fromDateDp.toggle()" (ngModelChange)="setMindate()" autocomplete="off">
            </div>
            <div class="col-4 form-group">
              <label for="to-date">To</label>
              <input id="to-date" class="form-control form-control-sm" container="body" placeholder="yyyy-mm-dd" ngbDatepicker #toDateDp="ngbDatepicker" [minDate]="minDate" [disabled]="historyListSearchForm?.value.fromDate === null" [maxDate]="maxDate" formControlName="toDate" (click)="toDateDp.toggle()" autocomplete="off">
            </div>

            <div class="col-12 text-right">
              <button class="btn btn-primary btn-sm" type="submit" id="search-data">Search</button>
              <button class="btn btn-warning btn-sm m-2" type="submit" id="search-data"
                (click)="clearSearchFilter()">Reset</button>
            </div>
          </div>
        </form>

      </div>
      <table class="table list-table-design" style="table-layout: fixed;">
        <thead class="TableHead">
          <tr>
            <th style="width: 25%;">Name</th>
            <th style="width: 17.5%;">Started on</th>
            <th style="width: 17.5%;">Ended on</th>
            <th style="width: 17%;">Environment Mapper</th>
            <th style="width: 17%;">Executed by</th>
            <th style="width: 11%;">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="dataList?.length === 0">
            <td colspan="10" class="text-center">
              <img height="100px" src="/assets/images/icons/empty_message.png" alt="/assets/images/icons/empty_message.png">
              <p style="color: gray;" class="ml-3 mt-1"><b>No Data Found</b></p>
            </td>
          </tr>
          <tr *ngFor="let data of dataList" class="clickable">
            <td class="text-truncate" title="{{data.name}}">
              <a *ngIf="executionType === 'TEST_CASE'"  [routerLink]="['/testcase',data.execution.executedTaskSqlId,'result']" [queryParams]="{executionId: data.execution.noSqlId}" target="_blank">{{data.name}}</a>
              <a *ngIf="executionType === 'TEST_SUITE'" [routerLink]="['/testsuite',data.execution.executedTaskSqlId,'result']" [queryParams]="{executionId: data.execution.noSqlId}" target="_blank">{{data.name}}</a>
              <a *ngIf="executionType === 'MASTER_SUITE'" [routerLink]="['/mastersuite',data.execution.executedTaskSqlId,'result']" [queryParams]="{executionId: data.execution.noSqlId}" target="_blank">{{data.name}}</a>
            </td>
            <td class="text-truncate">
              <div *ngIf="data.execution.startTime !== null">
                {{data.execution.startTime | localDate}}</div>
              <div *ngIf="data.execution.startTime === null">
                {{data.execution.executedOn | localDate}}</div>
            </td>
            <td class="text-truncate">
              <div *ngIf="data.execution.endTime === null">N/A</div>
              <div *ngIf="data.execution.endTime !== null">
                {{data.execution.endTime | localDate}}</div>
            </td>
            <td class="text-truncate" title="{{data.environmentMap.name}}">
              <div class="overflow-div-td">
                {{ data.environmentMap.name }}
              </div>
            </td>
            <td class="text-truncate" title="{{data.execution.executedBy}}">{{data.execution.executedBy}}</td>
            <td [ngClass]="data.execution.executionStatus">{{data.execution.executionStatus}}</td>
          </tr>
          <div *ngIf="dataList === 0">
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
            <p class="placeholder-glow py-1" style="height: 30px;color: black;">
              <span class="col-12"></span>
            </p>
          </div>
        </tbody>
      </table>
      <div *ngIf="!this.dataNotFound && this.dataLoaded" id="loadmore-box" class="text-center mt-4 mb-4">
        <span *ngIf="this.moreData" class="load-more-button" (click)="loadmore(this.page)">LOAD MORE</span>
      </div>
    </div>
  </div>
